// Ideally you should take these vars from process.env.REACT_APP_*
// and define them in e.g. .env.local (if you're using Create React App)

// Authorization screen base URL
// e.g. https://developer.github.com/apps/building-oauth-apps/authorizing-oauth-apps/#1-request-a-users-github-identity
// export const authorizationUrl = '';

// To get a client ID, create an app, e.g.
// GitHub (authorization code grant only): https://github.com/settings/developers
// Spotify (implicit grant & auth code): https://developer.spotify.com/dashboard/applications
export const clientId = '783uhxc6zlxx3k'; //LIAuthForAgility1st app

// You get to configure this in your OAuth settings
// If you use React Router, the relative path (empty here) can match
// that of a route which displays nothing

// GetLinkedInProfile AWS lambda function (liUserProfileUrl in production) expects redirectUri to be URL encoded
// export const redirectUri = 'https%3A%2F%2Fdev3331.dqw75gp69cprq.amplifyapp.com%2Flinkedin'; 
export const redirectUri = 'https%3A%2F%2Fw2sql.agility1st.com%2Flinkedin'; 

// Very strangely, for localhost, encoded URL does not work but unencoded one works.
// Uncomment below line for creating/running app on PC on localhost.
// export const redirectUri = 'http://localhost:3000/linkedin';
//export const redirectUri = `${window.location.origin}/linkedin`; //We should see if this works considering url encoding issues

// Authorization code flow only: base URL for your server
// The one provided below is that of the sample Express server provided
// export const serverUrl = 'http://localhost:5000';

// export const  appServerUrl = 'http://localhost:5000';
// export const  oauthServerUrl = 'http://localhost:5000';
// export const scope = '';

export const generalInstructionsOnUseOfTool = "1) Paste your Informatica workflow XML here in the editor.\n2) Choose your target: Spark SQL or Snowflake SQL.\n3) Refine your workflows and regenerate as needed.\n4) Download / copy SQLs and stats.\n\nDepending on workflow complexity, you will get multiple SQLs and statistics.";
export const linkedInLoginSuggestion = "\n\nLogin with your LinkedIn ID or the corporate account with us to get full-featured access."

export const liUserProfileUrl = "https://kxbaqh7ccvhvruor3sz6zojfxe0jwuis.lambda-url.us-east-1.on.aws/"; // Regular AWS Lambda fn.

export const w2sqlUrl = "https://hevza2mfqgkrgmjdiijnqzuylu0fbgeu.lambda-url.us-east-1.on.aws/";
